import R from 'ramda';
import {simpleCrud} from '../factories/simple-crud-component-makers.js';
import {openMultiSelect, openModal} from './helpers/simple-crud-helpers';
import {multiSelectInput} from '../mixins/multiselect-input';

export const toNumberMap = R.map(n => Number(n));

export const multiSelect = R.curry((template) => {

	let multiSelectConfig = {
		methods:  {
			openMultiSelect,
			openModal,
			onUpdateSuccess(body, input) {
				this.checkedItems = R.map(n => n, body.data);
			}

		},
		computed: {
			labels() {
				let check = R.filter(item => R.contains(item.id, this.checkedItems),this.list || []);
				return R.map(item => item.label, check)
			},
		},
		mixins: [multiSelectInput],
	};
	return simpleCrud(template,multiSelectConfig);
});
